export type ProjectCategory = "work" | "side" | "school";

export interface ProjectMeta {
  slug: string; // URL slug + renderProjectComponent key + translation prefix
  category: ProjectCategory;
  image: string;
}

// Ordered to match the portfolio grid display order.
export const PROJECTS: ProjectMeta[] = [
  { slug: "venn", category: "work", image: "/images/portfolio/venn.svg" },
  {
    slug: "aiassistant",
    category: "side",
    image: "/images/portfolio/aiassistant-min.webp",
  },
  { slug: "dag", category: "side", image: "/images/portfolio/dag-min.webp" },
  { slug: "jet", category: "work", image: "/images/portfolio/jet.webp" },
  {
    slug: "supply",
    category: "work",
    image: "/images/portfolio/supplyhouse.webp",
  },
  { slug: "yumso", category: "work", image: "/images/portfolio/yumso-min.webp" },
  { slug: "d3", category: "school", image: "/images/portfolio/p7-d3-min.webp" },
  { slug: "hci", category: "school", image: "/images/portfolio/p2-hci-min.webp" },
  { slug: "se", category: "school", image: "/images/portfolio/p1-se-min.webp" },
  {
    slug: "fitcat",
    category: "school",
    image: "/images/portfolio/p5-fitcat-min.webp",
  },
  {
    slug: "givenext",
    category: "school",
    image: "/images/portfolio/p6-givenext-min.webp",
  },
  {
    slug: "cscw",
    category: "school",
    image: "/images/portfolio/p3-cscw-min.webp",
  },
  {
    slug: "dataproduct",
    category: "school",
    image: "/images/portfolio/p8-dataproduct-min.webp",
  },
  {
    slug: "nonprofit",
    category: "side",
    image: "/images/portfolio/p9-nonprofit-min.webp",
  },
  {
    slug: "rapid",
    category: "school",
    image: "/images/portfolio/p4-rapid-min.webp",
  },
];

export const PROJECT_SLUGS = PROJECTS.map((p) => p.slug);

// Prev/next following grid order, scoped to the active filter:
// "*" traverses all projects; a category key stays within that category.
// Null at boundaries. Falls back to all projects if the slug isn't in scope.
export function getProjectNeighbors(
  slug: string,
  filter: string = "*",
): { prev: string | null; next: string | null } {
  let pool =
    filter === "*" ? PROJECTS : PROJECTS.filter((p) => p.category === filter);
  if (!pool.some((p) => p.slug === slug)) pool = PROJECTS;
  const i = pool.findIndex((p) => p.slug === slug);
  if (i === -1) return { prev: null, next: null };
  return {
    prev: i > 0 ? pool[i - 1].slug : null,
    next: i < pool.length - 1 ? pool[i + 1].slug : null,
  };
}
